<template>
    <div class="advanced-search"> 
        <div class="advanced-cont">
            <div class="cont-tips  ">
                <div class="tips">提示：</div>
                <div class="tips-info">
                    <div>1.高级检索顺序是<span>自上而下</span>的，请注意逻辑顺序.</div>
                    <div>2.在使用标点符号的时候请注意：</div>
                    <p>①使用<span>空格</span>理解成<span>“或”</span>的关系，如【组成：柴胡 当归】，查询组成为柴胡或者当归的方剂数据</p>
                    <p>②使用<span>中英文的逗号 分号 句号 冒号 顿号</span>理解成<span>“且”</span>的关系，如【出处：伤寒;金匮】，查询出处为伤寒并且为金匮的方剂数据</p>
                </div>
            </div>
            <div class="cont-search  ">
                <div v-if="searchType=='medical'" class="search-cont">
                    <div class="cont-tit">医案库信息：</div>
                    <div class="cont">
                        <el-checkbox-group class="info-checkbox" v-model="infoCheck">
                            <el-checkbox v-for="(item,index) in checkList" :key="index" :label='item.label'></el-checkbox> 
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="search-cont">
                    <div class="cont-tit">检索信息：</div>
                    <div class="cont">
                       <el-row  type="flex" class="row-bg" justify="space-between" v-for="(item,index) in searchList" :key='index'>
                            <el-col :span='2'>
                                <el-button @click='add_row()' v-if='index==0' plain type="primary" icon='el-icon-plus'> </el-button>
                                <el-select v-else v-model="item.relation" placeholder="请选择">
                                    <el-option
                                        v-for="item in relationList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span='4'>
                                <el-select   v-model="item.fieldName" placeholder="请选择">
                                    <el-option
                                        v-for="item in searchInfoList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-col>

                            <el-col :span='10'>
                                <el-input v-model="item.writeContent" ></el-input>
                            </el-col>
                            <el-col :span='4'>
                                <el-select   v-model="item.searchType" placeholder="请选择">
                                    <el-option
                                        v-for="item in queryType"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value" >
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span='2'>
                               <el-button  v-if='index!=0' type="text" @click="row_delete(item,index)">删除</el-button>
                            </el-col>
                       </el-row>
                    </div>
                </div>
                <div class="search-btn" >
                    <el-button type="primary" @click="search">检索</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie' 
export default {
    data () {
        return {
            searchType:this.$route.query.type||'',
            keyWord:[],
            infoCheck:['古代医案库','现代医案库','共享医案库','名医医案库',],
            checkList:[
                {
                    label:'古代医案库',
                },
                {
                    label:'现代医案库',
                },
                {
                    label:'共享医案库',
                },
                {
                    label:'名医医案库',
                },
            ],
            relationList:[
                { value:'AND', label:'与', },
                { value:'OR', label:'或', },
                { value:'NOT', label:'非', }
            ],
            searchList:[],
            searchInfoList:[],
            medicalList:[
                { value:'symptom', label:'临床表现', },
                { value:'tcm_medicine_diagnose', label:'中医疾病', },
                { value:'wcm_medicine_diagnose', label:'西医疾病', },
                { value:'tcm_syndrome_type_diagnose', label:'中医证候',},
                { value:'treatment_rule', label:'治法', },
                { value:'formula_name', label:'方剂名称', },
                { value:'formula_composition', label:'中药组成', },
                { value:'sourc', label:'医案来源', },
                { value:'medicaltext', label:'医案原文', },
                { value:'doctor_name', label:'医师姓名', },
            ],
            fangjiList:[
                { value:'cypmc', label:'名称', },
                { value:'cfjcc', label:'出处', },
                { value:'cfjzc', label:'组成', },
                { value:'cfjgy', label:'功用', },
                { value:'cfjzc1', label:'主治', },
                { value:'cfjyf', label:'用法', },
                { value:'cfjjj', label:'禁忌', },
                { value:'cfjfz', label:'附方', }, 
            ],
            queryType:[
                { value:'模糊', label:'模糊', },
                { value:'精确', label:'精确', }, 
            ],
        }
    },
    mounted () { 
        this.searchInfoList=this.medicalList; 
        let list = this.searchInfoList.slice(0,3)
        list.forEach((item,index)=>{
            let obj={ 
                relation:index>0?'AND':'',
                fieldName:item.value,
                writeContent:'',
                searchType:'模糊', 
            } 
            this.searchList.push(obj)
        }) 
    },
    methods: {
        add_row(){
            let obj= {
                relation:'AND',
                fieldName:this.searchInfoList[this.searchList.length+1].value,
                writeContent:'',
                searchType:'模糊',
            }; 
            this.searchList.push(obj)
        },
        row_delete(item,index){ 
            this.searchList.splice(index,1);
        },
        search(){
            window.localStorage.setItem("highSearchWord",''); 
            Cookies.set("highSearchWord",'')
            let num =0;
            this.keyWord=[];
            //高级检索时候过滤掉writeContent为空的数据
            let list= [];
            this.searchList.forEach((item,index) => {
                if(item.writeContent!=''){
                    num+=1;
                    this.keyWord.push(item.writeContent)
                    list.push(item)
                }
                item.isNum=index+1;
            });   
            //所有的搜索词都为空
            if(num==0){
                this.$message.error( '请输入检索词～')
                return
            }
            //highSearchWord参数过长，所以放到localStorage里，数据是json格式的
            window.localStorage.setItem("highSearchWord", JSON.stringify(list)); 
            Cookies.set("highSearchWord", JSON.stringify(list))
            
            this.medical_search(); 
        },  
        //医案高级搜索
        medical_search(){
            //params传参，刷新页面传递的值会丢失
            this.$router.push({
                name:'searchMedical', 
                query:{
                    sourceType:'advanced',
                    medicalLibraryId:this.infoCheck.join(';'),  
                    keyWord:this.keyWord.join(',')
                }
            }) 
        },
        fj_search(){
            this.$router.push({
                name:'searchPrescription', 
                query:{
                    sourceType:'advanced',
                    keyWord:this.keyWord.join(',')
                    // medicalLibraryId:this.infoCheck.join(';'),  
                }
            }) 
        },
    }
}
</script>

<style lang="less" >
    @import url('../css/advanced-search/advanced_search.less');
</style>
<style lang="less" scoped>
.search-btn{
    margin: 40px 0 20px;
    text-align: center;
}
//  .el-select-dropdown__item{
//     color: #97623C !important;
// }
</style>